define(
	'jqueryVersionAdapter',[
		'jquery'
	],
	function($) {
		'use strict';

		return {

			run: function() {
				// If the page is already running a jquery version which supports .on and .off we are fine
				if (typeof $.fn.on !== 'undefined') {
					return;
				}

				/*
				* However, if the page does not support these functions, we need to give them a valid
				* implementation since Backbone calls these internally. Bear in mind this is a VERY basic adapter
				* which is simple enough to handle only the overload cases Backbone uses. Any other javascript code
				* inside global header must NOT rely on .on and .off calls but use .bind instead
				*/
				$.fn.extend({
					on: function() {
						// .delegate arguments: (selector, eventName, method)
						if (arguments.length === 2) {
							return this.bind(arguments[0], arguments[1]);
						} else if (arguments.length === 3) {
							return this.find(arguments[1]).bind(arguments[0], arguments[2]);
						}
					},
					off: function(events) {
						return this.unbind(events);
					}
				});
			}
		};
	}
);

